import { render, staticRenderFns } from "./ConversationTemplate.vue?vue&type=template&id=36b3dc17&"
import script from "./ConversationTemplate.vue?vue&type=script&lang=js&"
export * from "./ConversationTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports